import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import {Q} from './pages/Q';
import LandingPage from './pages/LandingPage'; // Import your new landing page
import './App.css';
import TermsOfService from './pages/TermsOfService';
import PrivacyPolicy from './pages/PrivacyPolicy';
import RestaurantsPage from './pages/PartnerRestaurants';
import { DataProvider } from './context/DataContext';

function App() {

  return (
    <DataProvider>
    <Router>
      <Routes>
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/" element={<LandingPage />} />
            <Route path="/terms-of-service" element={<TermsOfService />} />
            <Route path="/partner-restaurants" element={<RestaurantsPage />} />
            <Route path="/qr" element={<Q/>} />
            <Route path="*" element={<Navigate to="/" />} />
            </Routes>
    </Router>
    </DataProvider>
  );
}

export default App;